/* Shared option lists + the empty form state for VendorApply. */

export const SERVICE_OPTIONS = [
  "Production",
  "DJ",
  "Catering",
  "Venue",
  "Photography/Videography",
  "Hair & Make-up",
  "Event planner",
  "Deco",
  "Florist",
  "Outfits",
  "Entertainment",
  "Wedding Cakes",
  "Wedding Stationery",
  "PhotoBooth",
  "Other",
];

export const REGION_OPTIONS = [
  "England",
  "Scotland",
  "Wales",
  "Northern Ireland",
  "Outside of UK (specify in 'Other details')",
  "Other",
];

export const COVERAGE_OPTIONS = [
  "UK only",
  "International only",
  "UK and International",
];

export const PRICING_STRUCTURE = [
  "Fixed packages",
  "Custom pricing only",
  "Packages + custom options",
  "Price available on enquiry",
];

export const PACKAGE_OPTIONS = [
  "Packages only",
  "Add-ons available",
  "Fully bespoke services",
  "Combination of all",
  "No packages",
];

export const INSURANCE_OPTIONS = [
  "Yes (up to £1M)",
  "Yes (£2M+)",
  "Yes (£5M+)",
  "No",
  "Currently arranging",
];

export const BUSINESS_OPTIONS = [
  "Sole trader",
  "Limited company",
  "Partnership",
  "Not currently registered",
  "Other",
];

export const YESNO = ["Yes", "No"];
export const ACCURACY_OPTIONS = ["Yes, I confirm", "No"];
export const RESPONSIBILITY_OPTIONS = ["Yes, I agree", "No"];

export const initialState = {
  full_name: "",
  company_name: "",
  email: "",
  contact_number: "",
  service_types: [],
  based_in: [],
  coverage: "",
  weddings_completed: "",
  pricing_structure: "",
  starting_price: "",
  packages_addons: "",
  public_liability_insurance: "",
  short_intro: "",
  business_registration: "",
  accuracy_confirmed: "",
  responsibility_agreed: "",
  public_display_consent: "",
  content_rights_confirmed: "",
  marketing_consent: "",
  uk_compliance_confirmed: "",
  other_details: "",
  intro_slot_date: "",
  intro_slot_time: "",
  declaration_confirmed: false,
  profile_picture_url: "",
};
